export class OmfCalculator {
    constructor(minInitiationFee = 165, maxInitiationFee = 1050, vatRate = 0.15) {
        this.minInitiationFee = minInitiationFee;
        this.maxInitiationFee = maxInitiationFee;
        this.vatRate = vatRate;
    }
    paymentCalc(presentValue, futureValue, annualInterest, term) {
        const rate = annualInterest/12;
        const temp = Math.pow((1 + rate), term);
        const fact = (1 + rate)*(temp - 1)/rate;
        return -(futureValue + presentValue * temp) / fact;
    }
    getDeduction(principalAmount, futureValue, annualInterest, term, creditLife, adminFee) {
        const pv = principalAmount + principalAmount / 360 * 45 * annualInterest;
        return this.paymentCalc(pv, futureValue, annualInterest, term) - principalAmount * creditLife/1000 - adminFee;
    }
    getInitiationFee(loanAmount) {
        let fee;
        if (loanAmount < 1000) {
            fee = loanAmount * this.vatRate;
        } else {
            fee = Math.min(this.maxInitiationFee, (loanAmount - 1000) * 0.1 + this.minInitiationFee);
            fee = fee * (1 + this.vatRate);
        }
        return fee;
    }
    getPrincipal(loanAmount) {
        let fee = this.getInitiationFee(loanAmount);
        return fee + loanAmount;
    }
    getCreditLifeFee(principal, creditLifeRate) {
        return principal * creditLifeRate / 1000;
    }
    getOfferBound(clRate, adminFee, annualInterest, affordability, minCapital, maxCapital, minTerm, maxTerm, loanAmount=null,
      loanTerm=null, capitalStepSize= 500) {
        if ((!loanAmount && !loanTerm) || (loanAmount && loanTerm)) {
            throw new Error('Must provide either a loanAmount or a loanTerm.');
        }

        if (loanAmount) {
            const range = [];
            for (let i = minTerm; i <= maxTerm; i++) {
                const principal = this.getPrincipal(loanAmount);
                const deduction = this.getDeduction(principal, 0, annualInterest, i, clRate, adminFee);
                if (-deduction <= affordability) {
                    range.push(i);
                }
            }

            if (!range.length) {
                return null;
            }

            return {
                minTerm: Math.min(...range),
                maxTerm: Math.max(...range)
            };
        } else {
            const range = [];
            for (let cap = minCapital; cap <= maxCapital; cap += capitalStepSize) {
                const principal = this.getPrincipal(cap);
                const deduction = this.getDeduction(principal, 0, annualInterest, loanTerm, clRate, adminFee);
                if (-deduction <= affordability) {
                    range.push(cap);
                }
            }

            if (!range.length) {
                return null;
            }

            return {
                minCapital: Math.min(...range),
                maxCapital: Math.max(...range)
            };
        }
    }
}
